export function parseVotingStatuses(voting) {
  if (voting) {
    let { canPublish, canAnnounceResult, isPublished, isInitial } = voting;

    return {
      disabled: !isInitial && !voting.isNew(),
      canSave: voting.isNew() || canPublish,
      canPublish,
      canAnnounceResult,
      isPublished
    };
  } else {
    return {
      disabled: false,
      canSave: true,
      canPublish: false,
      canAnnounceResult: false,
      isPublished: false
    };
  }
}

export function convertDate (date) {
  return date !== undefined && typeof date === 'number' ? new Date(date) : date;
}



// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/votings/helper.js